import React, { useContext, useEffect, Fragment } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import ClassroomAdmin from './Classroom';
import ClassroomSeller from './ClassroomSeller';
import AlertNotAuthorized from '../../Complements/AlertNotAuthorized';
import SchoolContext from '../../Reducers/Schools/SchoolContext';

export default function ClassroomIndex() {
   //Extraer la informacion de autenticación
   const authContext = useContext(AuthContext);
   const { usuario, usuarioAutenticado } = authContext;

   useEffect(() => {
    usuarioAutenticado();
  }, []);

  let component;
  if(usuario){
    switch (usuario.type) {
		case '1':
			component = <ClassroomAdmin />
			break;
		case '2':
			component = <ClassroomSeller />
			break;
		case '3':
			component = <ClassroomSeller />
			break;
		  default:
			component = <AlertNotAuthorized mensaje={"No tienes los suficientes permisos para ver esta página"}/>
			break;
    }
  }
  return (
    <Fragment>
      {component}
    </Fragment>
  )
}
